// extracted by mini-css-extract-plugin
export default {"tooltip-container":"InfoTag_tooltip-container__LrL9H","info-icon":"InfoTag_info-icon__vkAMH","tooltip-text":"InfoTag_tooltip-text__4E4UC"};